export type LogoType =
  | 'Footer'
  | 'Login'
  | 'Logo'
  | 'Navigation'
  | 'Negative'
  | 'NoFavorites'
  | 'NoResults'
  | 'Positive'
  | 'Symbol';

/**
 * Returns the logo name based on the provided brand and logo type.
 *
 * Constructs a logo name string by combining the `type` and the brand name,
 * following a specific naming convention for known brands. If the brand is not
 * recognized, it returns the `type` as the logo name.
 *
 * @param params - An object containing:
 *   @param params.brand - The brand for which to get the logo name.
 *   @param params.type - The type of logo.
 * @returns The constructed logo name as a `LogoName`.
 */

export const getLogoName = ({
  brand,
  type,
}: {
  brand: Content.Properties.Brand;
  type: LogoType;
}): LogoName => {
  switch (brand) {
    case 'golf':
      return `${type}Golf` as LogoName;

    case 'safari':
      return `${type}Safari` as LogoName;

    case 'rejseklubben':
      return `${type}Rejseklubben` as LogoName;

    default:
      return type as LogoName;
  }
};
